import { StyleSheet } from "@react-pdf/renderer";

// This package works very similarly to React Native's StyleSheet API but a lot less flexible.
// Hence the exact pixel coding. Sorry about that.

export const styles = StyleSheet.create({
  page: {
    backgroundColor: "#002744",
    color: "#fff",
  },
  topContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 30,
    paddingBottom: 0,
  },
  logoContainer: {
    flexDirection: "row",
    gap: 40,
    alignItems: "center",
    marginBottom: 30,
  },
  headingContainer: {
    gap: 12,
  },
  yourReport: {
    backgroundColor: "#9b258f",
    paddingHorizontal: 20,
    paddingVertical: 7,
    width: 140,
    borderRadius: 18,
    fontSize: 14,
    margin: "auto",
  },
  phone: {
    width: 190,
    height: 220,
    margin: "auto",
    marginTop: -15,
  },
  logo: {
    width: 120,
    height: 32,
  },

  totalResultContainer: {
    justifyContent: "center",
    position: "relative",
    transform: "translateX(50px)",
    width: 160,
  },
  totalResultImg: {},
  resultText: {
    fontSize: 24,
    position: "absolute",
    left: "40%",
    transform: "translateX(-40%)",
  },
  totalHeadingContainer: {
    color: "#000",
    transform: "translateX(80px)",
    position: "relative",
  },
  totalHeadingImg: {
    height: 90,
  },
  headingText: {
    fontSize: 22,
    position: "absolute",
    right: 80,
    top: 20,
  },
  arrowsContainer: {
    gap: 15,
    position: "relative",
    fontSize: 16,
  },
  percentContainer: { gap: 15, fontSize: 16, position: "relative" },
  arrow: {
    width: 200,
    height: 35,
  },
  percent: {
    width: 50,
    height: 35,
  },
  pieChart: {
    width: 150,
    height: 150,
    marginTop: -8,
    marginLeft: 15,
  },
  riskText: {
    position: "absolute",
    top: 10,
    left: 43,
  },
  processText: {
    position: "absolute",
    top: 60,
    left: 28,
  },
  environmentalText: {
    position: "absolute",
    top: 110,
    left: 8,
  },
  riskPercent: {
    position: "absolute",
    top: 11,
    left: "50%",
    transform: "translateX(-15%)",
  },
  processPercent: {
    position: "absolute",
    top: 60,
    left: "50%",
    transform: "translateX(-15%)",
  },
  environmentPercent: {
    position: "absolute",
    top: 110,
    left: "50%",
    transform: "translateX(-15%)",
  },
  description: {
    flexDirection: "row",
    margin: "auto",
    marginTop: 10,
    alignItems: "center",
    fontSize: 14,
    letterSpacing: 0.5,
  },
  iconContainer: {
    width: 55,
    height: 55,
    // react-pdf v4 rejects percentage border radius; half of width/height = a circle.
    borderRadius: 27.5,
    backgroundColor: "#fff",
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    transform: "translateX(20px)",
  },
  textContainer: {
    paddingLeft: 60,
    paddingRight: 30,
    paddingVertical: 10,
    zIndex: -10,
    width: 410,
  },

  footer: {
    position: "absolute",
    flexDirection: "row",
    justifyContent: "space-between",
    bottom: 0,
    left: 0,
    right: 0,
    paddingVertical: 10,
    paddingHorizontal: 30,
    textAlign: "center",
    color: "white",
    backgroundColor: "#9a258f",
    fontSize: 10,
    marginTop: 20,
  },
  footerLink: {
    color: "white",
    textDecoration: "none",
  },
});
